import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { constant } from 'app/app.constants';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ExcludeProviderService extends ParentService {
  constructor(private http: Http) {
    super();
  }

  getExcludeProviderListByRider(riderId: number): Observable<any> {
    return this.http.get(`${constant.URL_EXCLUDE_PROV_LIST_BY_RIDER}?riderId=${riderId}`, this.getHeader())
      .map((res: any) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  saveExcludeProviderbyRider(data: any): Observable<any> {
    return this.http.post(constant.URL_SAVE_EXCLUDE_PROV_BY_RIDER, data, this.headerPost())
      .map((res: any) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/exclude-providers/exclude-providers.service.ts